import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerDeepLinks } from '@/lib/platform/deepLinks';

/** Routes native deep links (Android/iOS) into the React Router. No-op on web. */
export function DeepLinkHandler() {
  const navigate = useNavigate();
  useEffect(() => registerDeepLinks((path) => navigate(path)), [navigate]);
  return null;
}
